import { inject, InjectionToken, Provider } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { RouteDataKey } from 'app/static/route-data-key.enum'

import { Footer } from './generated/api-types'

export const FOOTER_DATA = new InjectionToken<Footer>(ngDevMode ? 'FOOTER_DATA' : '')

export function provideFooterFromResolverRouteData(): Provider[] {
  return [{ provide: FOOTER_DATA, useFactory: () => inject(ActivatedRoute).snapshot.data[RouteDataKey.FOOTER] }]
}
